(function ($) {
  jQuery(document).ready(function () {
    //jQuery("a[href='#modal_request_quote']").on("click", function (event) {
    //jQuery("#modal_request_quote").modal("toggle");
    //});
  });
})(jQuery);
